import React, { useState } from 'react';
import { AppBar, Toolbar, Button, IconButton, Drawer, MenuItem, Menu, useMediaQuery, Box, Divider } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useTranslation } from 'react-i18next';
import { normalizeKey } from '../i18n';

const MenuComponent = ({ onSelectCategory }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openSubMenu, setOpenSubMenu] = useState(null);
  const isMobile = useMediaQuery('(max-width:768px)');
  const { t } = useTranslation(); // i18n hook

  const toggleDrawer = () => setDrawerOpen(!drawerOpen);

  const handleClick = (event, category) => {
    setAnchorEl(event.currentTarget);
    setOpenSubMenu(category);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpenSubMenu(null);
  };
  
     {/* { key: 'clothing', label: t('clothing') },
    { key: 'homekitchen', label: t('home_kitchen') },
    { key: 'appliances', label: t('appliances') },
    { key: 'sports', label: t('sports_more') },
    { key: 'essentials', label: t('essentials') },
    { key: 'global', label: t('global_shopping') },*/}

{/*  const categories = [
    { key: 'all', label: t('all') },
    { key: 'electronics', label: t('electronics') },
      { key: 'fruitsvegetables', label: t('Fruits & Vegetables') },
      { key: 'foodgrains', label: t('Foodgrains') },
      { key: 'oilmasala', label: t('Oil & Masala') },
      { key: 'bakerycakesdairy', label: t('Bakery, Cakes & Dairy') },
      { key: 'beverages', label: t('Beverages') },
      { key: 'snacks', label: t('Snacks') },
      { key: 'household', label: t('HouseHold & Cleaning') },
     { key: 'meat', label: t('Eggs,Meat & Fish') },
     { key: 'beauty', label: t('Beauty & Care') },
      { key: 'offers', label: t('Offers') },
  ];
 */}
  
   const categories = [
    { key: 'all', label: t('all', 'All') },
    { key: 'fruits', label: t('fruits','Fruits') },
      { key: 'vegetables', label: t('vegetables','Vegetables') },
      { key: 'groceries', label: t('groceries', 'Groceries') },
       { key: 'meat', label: t('eggs_and_meat', 'Eggs & Meat') },
           { key: 'greens', label: t('greens','Greens') },
        { key: 'natural', label: t('natural','Natural Products') },
      { key: 'offers', label: t('offers','Offers') },
  ];
  
  const grocerySubcategories = [
  { key: 'pulses_lentils', label: t('pulses_lentils', 'Pulses & Lentils') },
  { key: 'rice_grains', label: t('rice_grains', 'Rice & Grains') },
  { key: 'flours', label: t('flours', 'Flours') },
  { key: 'spices_masalas', label: t('spices_masalas', 'Spices & Masalas') },
  { key: 'oils_ghee', label: t('oils_ghee', 'Oils & Ghee') },
  { key: 'salt_sugar_jaggery', label: t('salt_sugar_jaggery', 'Salt, Sugar & Jaggery') },
  { key: 'dry_fruits_nuts', label: t('dry_fruits_nuts', 'Dry Fruits & Nuts') },
  { key: 'tea_coffee', label: t('tea_coffee', 'Tea & Coffee') },
];
  
   const mobileMenu = (
    <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer}>
      <div onClick={toggleDrawer} onKeyDown={toggleDrawer}>
        {categories.map(({ key, label }) => (
          <MenuItem
            key={key}
            onClick={(e) =>
              key === 'meat'  || key === 'groceries'
                ? handleClick(e, key)
                : onSelectCategory(key, null)
            }
          >
            {label}
          </MenuItem>
        ))}
      </div>
    </Drawer>
  );

  const desktopMenu = (
    <Toolbar>
      {categories.map(({ key, label }) => (
        <Button
          key={key}
          color="inherit"
          onClick={(e) =>
            key === 'meat' || key === 'groceries'
              ? handleClick(e, key)
              : onSelectCategory(key, null)
          }
        >
          {label}
        </Button>
      ))}
    </Toolbar>
  );
  
 {/* const mobileMenu = (
    <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer}>
      <div onClick={toggleDrawer} onKeyDown={toggleDrawer}>
        {categories.map(({ key, label }) => (
          <MenuItem
            key={key}
            onClick={(e) =>
              key === 'electronics' || key === 'foodgrains' || key === 'oilmasala'
                ? handleClick(e, key)
                : onSelectCategory(key, null)
            }
          >
            {label}
          </MenuItem>
        ))}
      </div>
    </Drawer>
  );

  const desktopMenu = (
    <Toolbar>
      {categories.map(({ key, label }) => (
        <Button
          key={key}
          color="inherit"
          onClick={(e) =>
            key === 'electronics' || key === 'foodgrains' || key === 'oilmasala'
              ? handleClick(e, key)
              : onSelectCategory(key, null)
          }
        >
          {label}
        </Button>
      ))}
    </Toolbar>
  );
 */}
  return (
    <AppBar position="static" sx={{ bgcolor: '#4D7B2B', color: '#FFFFFF' }}>
      {isMobile ? ( 
        <>
          <Toolbar>
            <IconButton edge="start" color="inherit" aria-label="menu" onClick={toggleDrawer}>
              <MenuIcon />
            </IconButton>
          </Toolbar>
          {mobileMenu}
        </>
      ) : (
        desktopMenu
      )}

      {/* SubMenus */}
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl) && openSubMenu === 'meat'} onClose={handleClose}>
        <MenuItem onClick={() => { onSelectCategory('Eggs & Meat', 'Chicken'); handleClose(); }}>
          {t('chicken','Chicken')}
        </MenuItem>
        <MenuItem onClick={() => { onSelectCategory('Eggs & Meat', 'Beef'); handleClose(); }}>
          {t('beef','Beef')}
        </MenuItem>
        <MenuItem onClick={() => { onSelectCategory('Eggs & Meat', 'Eggs'); handleClose(); }}>
          {t('eggs', 'Eggs')}
        </MenuItem>
      </Menu>
              <Menu
  anchorEl={anchorEl}
  open={Boolean(anchorEl) && openSubMenu === 'groceries'}
  onClose={handleClose}
>
  {grocerySubcategories.map(({ key, label }) => (
    <MenuItem
      key={key}
      onClick={() => {
        onSelectCategory('Groceries', label);
        handleClose();
      }}
    >
      {label}
    </MenuItem>
  ))}
</Menu>
    </AppBar>
  );
};

export default MenuComponent;